var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-skeleton"},[_c('div',{staticClass:"tree-box"},[_vm._l((_vm.lines),function(key){return [_c('div',{key:key,staticClass:"tree-node"})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }